import { commonColor } from '/@/utils/color'

export enum FlightMissionPlanType {
  Preblast = 0,
  Blast = 1,
  Basemap = 2,
  Survey = 3,
}

export const FlightMissionPlanTypeMap = {
  [FlightMissionPlanType.Preblast]: 'Pre-Blast',
  [FlightMissionPlanType.Blast]: 'Blast',
  [FlightMissionPlanType.Basemap]: 'Base Map',
  [FlightMissionPlanType.Survey]: 'Survey',
}

export const FlightMissionPlanTypeOptions = [
  { value: FlightMissionPlanType.Preblast, label: FlightMissionPlanTypeMap[FlightMissionPlanType.Preblast] },
  { value: FlightMissionPlanType.Blast, label: FlightMissionPlanTypeMap[FlightMissionPlanType.Blast] },
  { value: FlightMissionPlanType.Basemap, label: FlightMissionPlanTypeMap[FlightMissionPlanType.Basemap] },
  { value: FlightMissionPlanType.Survey, label: FlightMissionPlanTypeMap[FlightMissionPlanType.Survey] },
]

export const FlightMissionPlanTypeNameMap = {
  [FlightMissionPlanType.Preblast]: 'preblast',
  [FlightMissionPlanType.Blast]: 'blast',
  [FlightMissionPlanType.Basemap]: 'base',
  [FlightMissionPlanType.Survey]: 'survey',
}
